import ClearIcon from "@mui/icons-material/Clear";
import { Rule, RuleGroup, useRuleStore } from "csi/middleware/attributeRule/RuleStore";
import IconButton from "designSystem/components/button/IconButton";
import { FlexColumn, FlexRowCenter, OverflowText, SingleSelect } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { ComponentItem } from "designSystem/types/component-item-types";
import _ from "lodash";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import CustomViewFilterLeftColumn from "./CustomViewFilterLeftColumn";
import CustomViewFilterValueSelection from "./CustomViewFilterValueSelection";

interface CustomViewFilterGridProps {
	rule: Rule;
	ruleGroup: RuleGroup;
}

const CustomViewFilterGrid: FunctionComponent<CustomViewFilterGridProps> = observer(({ rule, ruleGroup }) => {
	const ruleStore = useRuleStore();

	const {
		options,
	} = ruleStore || {};

	const {
		allConditions,
		count,
		removeRule,
		selectedCondition,
		setSelectedAttribute,
		setSelectedCondition,
		setSelectedOperator,
	} = ruleGroup;

	const {
		operators,
		index,
		item,
		relativeTypeText,
		selectedOperator,
	} = rule || {};

	return (
		<FlexColumn 
			data-csi-automation="CustomViewFilterGroupItem"
			my={3}
		>
			<FlexRowCenter>
				<CustomViewFilterLeftColumn
					count={count}
					index={index}
					isFlexRow
					onChange={setSelectedCondition}
					options={allConditions}
					value={selectedCondition}
				/>
				<FlexColumn
					bgcolor={grey[100]}
					border={STANDARD_BORDER_STYLE}
					borderRadius={1}
					pl={4}
					pr={2}
					py={2}
					width={1}
				>
					<FlexRowCenter>
						{!_.isEmpty(options) && (
							<SingleSelect
								disableClearable
								forcePopupIcon
								fullWidth
								groupBy={(option) => option.group}
								onChange={(event, value, reason) => setSelectedAttribute(value as ComponentItem, index)}
								options={options}
								value={item}
							/>
						)}
						{!_.isEmpty(operators) && (
							<SingleSelect
								fullWidth
								onChange={(event, newValueItem, reason) => setSelectedOperator(newValueItem, index)}
								options={operators}
								required
								value={selectedOperator}
							/>
						)}
						<CustomViewFilterValueSelection
							filter={rule}
							filterGroup={ruleGroup}
							index={index}
						/>
						<IconButton
							onClick={() => removeRule(index)}
							size="large"
						>
							<ClearIcon />
						</IconButton>
					</FlexRowCenter>
				</FlexColumn>
			</FlexRowCenter>
			{relativeTypeText && (
				<FlexRowCenter pt={1}>
					<OverflowText text={relativeTypeText} />
				</FlexRowCenter>
			)}
		</FlexColumn>
	);
});

export default CustomViewFilterGrid;